import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clipboard". Copies the text content of the
// element referenced by data-clipboard-target="source" to the clipboard
// when the button (data-action="clipboard#copy") is clicked, briefly
// flipping its label to a confirmation.
export default class extends Controller {
  static targets = ["source", "button"]
  static values = { copiedLabel: String }

  async copy() {
    await navigator.clipboard.writeText(this.sourceTarget.textContent)

    const original = this.buttonTarget.textContent
    if (this.hasCopiedLabelValue) this.buttonTarget.textContent = this.copiedLabelValue
    setTimeout(() => { this.buttonTarget.textContent = original }, 1500)
  }
}
